export enum EApiType {
  Admin = 'admin',
  Bank = 'bank',
  Customer = 'customer',
}
